import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { InternalBankReplenishBody } from "./internalBankReplenishmentUpdate.types";

export const requestInternalBankReplenishmentUpdate = async ({
  id,
  ...body
}: InternalBankReplenishBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesInternalBank.InternalBankReplenishment, id),
    body
  );
};
